module.exports = __webpack_public_path__ + "static/media/imac-scrn-design.6cccd43f.jpg";